module.exports = __webpack_public_path__ + "static/media/FontsFree-Net-FuturaStdHeavy.0d371eae.svg";